import { linter, Diagnostic } from "@codemirror/lint";
import * as acorn from "acorn";

function acornLinter(view: any): Diagnostic[] {
    let eventCount = 0
    const diagnostics: Diagnostic[] = [];
    let code = view.state.doc.toString();
    // Réinitialise le compteur à chaque invocation
    eventCount = 0;
    // Remplace chaque @on(...) par une fonction __tilmiEvent_{1,2,3...}()
    code = code.replace(
        /@on\((.*?)\)\s*\{/g,
        () => {
            eventCount += 1;
            return `function __tilmiEvent_${eventCount}() {`;
        }
    ); try {
        acorn.parse(code, {
            ecmaVersion: "latest",
            sourceType: "module",
            locations: true, // pour obtenir la position de l'erreur
        });
    } catch (err: any) {
        if (err.loc) {
            // Calculer la position dans le document
            const line = err.loc.line;
            const column = err.loc.column;
            // Récupérer la position de début de la ligne
            const lineInfo = view.state.doc.line(line);
            const pos = lineInfo.from + column;

            diagnostics.push({
                from: pos,
                to: pos,
                severity: "error",
                message: err.message,
            });
        } else {
            diagnostics.push({
                from: 0,
                to: 0,
                severity: "error",
                message: err.message,
            });
        }
    }
    return diagnostics;
}

export const acornLinterExtension = linter(acornLinter);
export { acornLinter };
